
import Cell from 'vux/src/components/cell/index.vue'

import store from '../../vuex/store'
import { go } from '../../libs/router'
export default {
components: {
Cell
},
data () {
return {
}
},
mounted () {
store.commit( 'UPDATE_TITLE', '关于我们' )
},
created () {
store.commit( 'UPDATE_SHOW_FOOTER', false )
},
methods: {
onClick ( link ) {
go( link, this.$router )
}
}
}



// WEBPACK FOOTER //
// ./src/components/user/about.vue